<template>
  <v-expansion-panel-header
    :color="color"
    elevation="0"
    class="px-4 grey--text text--darken-2 subtitle-2 font-weight-bold"
    :disable-icon-rotate="showCompleteState"
  >
    <slot></slot>
    <div v-if="required" class="red--text ml-1">*</div>
    <template v-if="showCompleteState" #actions>
      <v-icon color="green lighten-1">check_circle</v-icon>
    </template>
  </v-expansion-panel-header>
</template>

<script>
export default {
  name: 'ExtractionFieldHeader',
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
    complete: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showCompleteState() {
      return !this.open && this.complete;
    },
    color() {
      if (this.error) {
        return 'red lighten-4';
      }
      return this.showCompleteState
        ? 'green lighten-5'
        : 'grey lighten-5';
    },
  },
};
</script>
